import { getParameters, postParameter, putParameter } from '../../../Api/services/backoffice';

export const key = 'parameter';

const entityName = {
  singular: 'Parâmetro',
  plural: 'Parâmetros',
};

const queries = {
  list: { key, fn: getParameters },
  detail: { key },
};

const mutations = {
  create: postParameter,
  update: putParameter,
};

const fields = {
  table: [
    { key: 'description', label: 'Descrição' },
    { key: 'value', label: 'Valor' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  hideCreateButton: true,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
